import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseRestService} from '../../common/BaseRestService';
import {BeneficiaryData, BeneficiaryDataGetResponse} from '../../../types/nso-data-portal/census-data';

@Injectable()
export class BeneficiaryRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('census/beneficiaryCategory');
  }

  getBeneficiaries(size: number, page: number, name: string): Observable<BeneficiaryDataGetResponse> {
    const params = new HttpParams()
      .set('size', String(size))
      .set('page', String(page))
      .set('name', name);
    return this.http.get<BeneficiaryDataGetResponse>(this.getEndpoint(['search']), {params});
  }

  getBeneficiaryTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.getEndpoint(['types']));
  }

  getBeneficiarySubTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.getEndpoint(['subTypes']));
  }

  createBeneficiary(beneficiary: BeneficiaryData) {
    return this.http.post<BeneficiaryData>(this.getEndpoint(), beneficiary);
  }

  updateBeneficiary(beneficiary: BeneficiaryData) {
    return this.http.put<BeneficiaryData>(this.getEndpoint(), beneficiary);
  }

  deleteBeneficiary(beneficiary: BeneficiaryData) {
    return this.http.delete<BeneficiaryData>(this.getEndpoint([String(beneficiary.id)]));
  }
}
